(function () {
  function activateTab(section, tabId) {
    var intro = section.querySelector('.lp-product-info-tabs__info-text--intro');
    var panels = section.querySelectorAll('.lp-product-info-tabs__info-text--panel');
    var items = section.querySelectorAll('.lp-product-info-tabs__item');
    var triggers = section.querySelectorAll('.lp-product-info-tabs__trigger');

    panels.forEach(function (panel) {
      var isMatch = panel.getAttribute('data-tab-panel') === tabId;
      panel.classList.toggle('is-active', isMatch);
    });

    if (intro) {
      intro.classList.add('is-hidden');
    }

    items.forEach(function (item) {
      var trigger = item.querySelector('.lp-product-info-tabs__trigger');
      var isMatch = trigger && trigger.getAttribute('data-tab-trigger') === tabId;
      item.classList.toggle('is-active', isMatch);
    });

    triggers.forEach(function (trigger) {
      var isMatch = trigger.getAttribute('data-tab-trigger') === tabId;
      trigger.setAttribute('aria-selected', isMatch ? 'true' : 'false');
    });
  }

  function initProductInfoTabs(section) {
    var triggers = section.querySelectorAll('.lp-product-info-tabs__trigger');

    triggers.forEach(function (trigger) {
      trigger.addEventListener('click', function () {
        var tabId = trigger.getAttribute('data-tab-trigger');
        if (tabId) {
          activateTab(section, tabId);
        }
      });
    });

    var activeTrigger = section.querySelector('.lp-product-info-tabs__item.is-active .lp-product-info-tabs__trigger');
    if (activeTrigger) {
      var activeTabId = activeTrigger.getAttribute('data-tab-trigger');
      if (activeTabId) {
        activateTab(section, activeTabId);
      }
    }
  }

  function initAll() {
    document.querySelectorAll('.lp-product-info-tabs').forEach(initProductInfoTabs);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var section = event.target.querySelector('.lp-product-info-tabs');
    if (section) {
      initProductInfoTabs(section);
    }
  });
})();
